import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Register() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      navigate("/");
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div data-testid="register-page" className="pt-32 md:pt-40 pb-24 min-h-[80vh]">
      <div className="max-w-md mx-auto px-6">
        <div className="overline mb-5">{t("auth.register_overline")}</div>
        <h1 className="font-serif text-5xl text-[#F5F5F0] mb-12 leading-[0.95]">
          {t("auth.register_title_1")} <em className="text-[#D4AF37] not-italic">{t("auth.register_title_2")}</em>
        </h1>
        <form onSubmit={submit} className="space-y-5" data-testid="register-form">
          <div>
            <label className="lux-label">{t("auth.name")}</label>
            <input value={form.name} onChange={set("name")} className="lux-input" required data-testid="register-name" />
          </div>
          <div>
            <label className="lux-label">{t("auth.email")}</label>
            <input type="email" value={form.email} onChange={set("email")} className="lux-input" required data-testid="register-email" />
          </div>
          <div>
            <label className="lux-label">{t("auth.password_hint")}</label>
            <input type="password" value={form.password} onChange={set("password")} className="lux-input" required minLength={6} data-testid="register-password" />
          </div>
          {error && <div data-testid="register-error" className="text-sm text-red-400 border border-red-900/60 bg-red-900/10 p-3">{error}</div>}
          <button type="submit" disabled={loading} data-testid="register-submit" className="btn-primary w-full disabled:opacity-60">
            {loading ? t("auth.creating") : t("auth.register_cta")}
          </button>
        </form>
        <p className="text-sm text-[#A3A39D] mt-10">
          {t("auth.have_account")}{" "}
          <Link to="/login" data-testid="to-login-link" className="text-[#D4AF37] hover:text-[#F0C050]">{t("auth.sign_in")}</Link>
        </p>
      </div>
    </div>
  );
}
